/*******
* js functionality for secondary nav component
*
********/

/**
 * Define toggle buttons
 */
var nav_toggle_trigger = $('nav.secondary').find('.toggle-button');


/**
 * On click of nav toggle buttons:
 *  - prevent the link from firing
 *  - toggle menu level-2
 *  - swap the toggle buttons (ie, plus becomes minus and vice-versa)
 */
nav_toggle_trigger.click(function(e){
	
	// prevent link from firing
	e.preventDefault();

	// slide toggle menu level-2
	$(this).parents('li').children('ul.level-2').slideToggle('fast');

	// swap the toggle button icons
	$(this).parent('a').find('.toggle-button').toggle()

});